

import RequestDetailMaterial = require("../../requestDetail/models/requestMaterial");
import Detail = require("../../requestDetail/models/requestDetail");
import RequestDetailPackages = require("../../requestDetail/models/packages");
import RequestDetailMaterials = require("../../requestDetail/models/materials");
import { RequestAllDetails } from '../../requestDetail/models/requestAllDetails'
import { RequestLetter} from '../../requestDetail/models/requestLetter';

import { IChangeTracking } from '../../../changeTracking/iChangeTracking';
import { WizardStep } from '../../../../core/wizard/wizardStep';
import { INotificationService } from '../../../../core/notificationService';
import { IAddRequestService } from '../services/addRequestService';
import { IChangeTrackingService } from '../../../changeTracking/iChangeTrackingService';

import { RequestDetailEdit } from '../../requestDetailEdit/models/requestDetailEdit';

import { RequestDetail } from '../../requestDetailEdit/models/requestDetail';
import { RequestConsignee } from '../../requestDetailEdit/models/requestConsignee';
import { RequestShipment } from '../../requestDetailEdit/models/requestShipment';
import { RequestPickupDetail } from '../../requestDetailEdit/models/requestPickupDetail';

import { RequestMaterial} from '../../requestDetailEdit/models/requestMaterial';
import { RequestMaterials } from '../../requestDetailEdit/models/requestMaterials';
import { RequestPackages } from '../../requestDetailEdit/models/requestPackages';
import { RequestAssignedMaterialToPackage } from '../../requestDetailEdit/models/requestAssignedMaterialToPackage';
import { RequestAttachments } from '../../requestDetailEdit/models/requestAttachments';

import '../../../../core/saveResult';



import { requestDetailEditState } from "../../requestDetailEdit/states/requestDetailEditState";
import { requestDetailState } from '../../requestDetail/states/requestDetailState';
import { UserInfoService } from '../../../userInfo/services/UserInfoService';

export class AddRequestController implements IChangeTracking {

    isLoading = true;
    isValid = false;
    isSaved = false;
    onClickCheck = false;
    onClickMessage = ''


    unmodifiedRequestDetailEdit: RequestDetailEdit;

    requestDetailEdit: RequestDetailEdit;


    shippingDetailsStep: WizardStep = {
        title: 'Shipment Location (Ship To)',
        nextButtonText: 'Next',
        backAction: null,
        nextAction: null
    };
    addMaterialsStep: WizardStep = {
        title: 'Add Materials',
        nextButtonText: 'Next',
        backAction: null,
        nextAction: null
    };
    addPackagesStep: WizardStep = {
        title: 'Add Packages',
        nextButtonText: 'Next',
        backAction: null,
        nextAction: <any>(() => this.onClickofAddPackagesNext())

    };
    assignMaterialsToPackagesStep: WizardStep = {
        title: 'Assign Materials to Packages',
        nextButtonText: 'Next',
        backAction: null,
        nextAction: <any>(() => this.onClickofAssignMaterialToPackagesNext())
    };
    pickupInformationStep: WizardStep = {
        title: 'Shipment Location (Ship From)',
        nextButtonText: 'Next',
        backAction: null,
        nextAction: null
    };
    extraDetailsStep: WizardStep = {
        title: 'Include Extra Request Details',
        nextButtonText: 'SUBMIT',
        backAction: null,
        nextAction: <any>(() => this.submitRequestDetails())
    };

    confirmationStep: WizardStep = {
        title: 'Confirmation',
        nextButtonText: 'DONE',
        backAction: null,
        nextAction: <any>(() => this.redirectToSearchPage())
    };


    wizardSteps: WizardStep[] = [
        this.shippingDetailsStep, this.addMaterialsStep, this.addPackagesStep, this.assignMaterialsToPackagesStep,
        this.pickupInformationStep, this.extraDetailsStep, this.confirmationStep
    ];

    currentStep = this.shippingDetailsStep;

    static $inject = ['$state', '$stateParams', '$scope', '$q',
        'addRequestService', 'UserInfoService', 'NotificationService', 'ChangeTrackingService', '$filter'];


    private _copyRequestDetailEdit: RequestDetailEdit;

    constructor(private _$state: ng.ui.IStateService,
        private _$stateParams: angular.ui.IStateParamsService,
        private _$scope: angular.IScope,
        private $q: ng.IQService,
        private _addRequestService: IAddRequestService,
        private _userInfoService: UserInfoService,
        private _notificationService: INotificationService,
        private changeTrackingService: IChangeTrackingService,
        private $filter: ng.IFilterService) {
    }

    attachmentFormData;
    requestAllDetails: RequestAllDetails;

    $onInit() {
        this.isLoading = true;
        this.changeTrackingService.initializeTracking(this);
        this._copyRequestDetailEdit = this._$stateParams['copyRequestDetailEdit'];

        if (this._copyRequestDetailEdit !== undefined && this._copyRequestDetailEdit !== null) {

            this.handleCopyGetDetail(this._copyRequestDetailEdit);
        } else {
            this.loadEmptyRequestDetailEditModel();
        }

        this.attachmentFormData = new FormData();
    }

    private loadEmptyRequestDetailEditModel(): void {
        this.requestDetailEdit = angular.copy(this.getEmptyRequestDetailEditModel(this.requestDetailEdit));
        this.unmodifiedRequestDetailEdit = angular.copy(this.requestDetailEdit);
        this.isLoading = false;
    }


    private getEmptyRequestDetailEditModel(rqDetailEdit: RequestDetailEdit): RequestDetailEdit {

        if (rqDetailEdit === undefined || rqDetailEdit === null) {
            rqDetailEdit = new RequestDetailEdit(undefined);
        }

        if (rqDetailEdit.requestDetail === undefined || rqDetailEdit.requestDetail === null) {
            rqDetailEdit.requestDetail = new RequestDetail(undefined);
        }

        if (rqDetailEdit.requestDetail.requestConsignee === undefined || rqDetailEdit.requestDetail.requestConsignee === null) {
            rqDetailEdit.requestDetail.requestConsignee = new RequestConsignee(undefined);
        }

        if (rqDetailEdit.requestDetail.requestShipment === undefined || rqDetailEdit.requestDetail.requestShipment === null) {
            rqDetailEdit.requestDetail.requestShipment = new RequestShipment(undefined);
        }

        if (rqDetailEdit.requestDetail.requestPickupDetail === undefined || rqDetailEdit.requestDetail.requestPickupDetail === null) {
            rqDetailEdit.requestDetail.requestPickupDetail = new RequestPickupDetail(undefined);
        }

        if (rqDetailEdit.requestMaterial === undefined || this.requestDetailEdit.requestMaterial === null) {
            rqDetailEdit.requestMaterial = new RequestMaterial(undefined);
        }


        return rqDetailEdit;
    }

    private handleCopyGetDetail(details: RequestDetailEdit): void {


        var copyRequestInitialLoadRequestDetailEdit = angular.copy(this.setIdValuesToUndefinedOnCopyRequest(details));


        this.requestDetailEdit = this
            .loadAllPackagesWithAssignedQuantityToAssignMaterials(angular
                .copy(copyRequestInitialLoadRequestDetailEdit));

        this.unmodifiedRequestDetailEdit = angular.copy(this.getEmptyRequestDetailEditModel(this.unmodifiedRequestDetailEdit));
        this.isLoading = false;


    }

    private setIdValuesToUndefinedOnCopyRequest(details: RequestDetailEdit): RequestDetailEdit {
        if (details !== undefined) {
            details.trackingId = angular.copy(undefined);

            if (details.requestDetail !== undefined && details.requestDetail.requestShipment !== undefined) {
                details.requestDetail.requestShipment.requestedDeliveryDate = angular.copy(undefined);
                details.requestDetail.requestShipment.shipmentReadyDate = angular.copy(undefined);
            }

            if (details.requestDetail !== undefined && details.requestDetail.requestPickupDetail !== undefined) {
                details.requestDetail.requestPickupDetail.pickupId = angular.copy(undefined);
            }


            if (details.requestDetail !== undefined && (details.requestDetail.requestPickupDetail === undefined ||
                details.requestDetail.requestPickupDetail === null)) {
                details.requestDetail.requestPickupDetail = new RequestPickupDetail(undefined);
            }

            if (details.requestMaterial !== undefined) {
                if (details.requestMaterial.requestMaterials !== undefined) {
                    for (var im = 0; im < details.requestMaterial.requestMaterials.length; im++) {
                        if (details.requestMaterial.requestMaterials[im] !== undefined) {
                            details.requestMaterial.requestMaterials[im].materialId = angular.copy(undefined);
                        }
                    }
                }

                if (details.requestMaterial.requestPackages !== undefined) {
                    for (var ip = 0; ip < details.requestMaterial.requestPackages.length; ip++) {
                        if (details.requestMaterial.requestPackages[ip] !== undefined) {
                            details.requestMaterial.requestPackages[ip].packageId = angular.copy(undefined);
                            details.requestMaterial.requestPackages[ip].quantity = angular.copy(undefined);
                        }
                    }
                }


                if (details.requestMaterial.requestAssignedMaterialToPackage !== undefined) {
                    for (var ia = 0; ia < details.requestMaterial.requestAssignedMaterialToPackage.length; ia++) {
                        if (details.requestMaterial.requestAssignedMaterialToPackage[ia] !== undefined) {
                            if (details.requestMaterial.requestAssignedMaterialToPackage[ia].requestMaterials !==
                                undefined) {
                                details.requestMaterial.requestAssignedMaterialToPackage[ia].requestMaterials
                                    .materialId = angular.copy(undefined);
                            }

                            if (details.requestMaterial.requestAssignedMaterialToPackage[ia].requestPackages !==
                                undefined) {
                                for (var iap = 0;
                                    iap <
                                    details.requestMaterial.requestAssignedMaterialToPackage[ia].requestPackages
                                        .length;
                                    iap++) {
                                    if (details.requestMaterial.requestAssignedMaterialToPackage[ia]
                                        .requestPackages[iap] !==
                                        undefined) {
                                        details.requestMaterial.requestAssignedMaterialToPackage[ia]
                                            .requestPackages[iap]
                                            .packageId = angular.copy(undefined);
                                    }
                                }
                            }
                        }
                    }
                }


                if (details.requestMaterial.requestAttachments !== undefined) {

                    details.requestMaterial.requestAttachments = [];
                }



            }

        }

        return details;
    }

    private loadAllPackagesWithAssignedQuantityToAssignMaterials(loadAssignMaterialsRequestDetailEdit: RequestDetailEdit):
        RequestDetailEdit {

        var packagesLoadRequestDetailEdit = this.loadAllPackagesToAssignMaterials(
            angular.copy(loadAssignMaterialsRequestDetailEdit));
        return this.loadAssignedPackagesToAssignMaterial(angular.copy(packagesLoadRequestDetailEdit),
            angular.copy(loadAssignMaterialsRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage));

    }

    private loadAllPackagesToAssignMaterials(loadAllRequestDetailEdit: RequestDetailEdit): RequestDetailEdit {

        if (loadAllRequestDetailEdit !== undefined &&
            loadAllRequestDetailEdit.requestMaterial !== undefined &&
            loadAllRequestDetailEdit.requestMaterial.requestPackages !== undefined &&
            loadAllRequestDetailEdit.requestMaterial.requestMaterials !== undefined &&
            loadAllRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined) {
            for (var iamp = 0;
                iamp < loadAllRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length;
                iamp++
            ) {

                loadAllRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iamp].requestPackages = [];
                loadAllRequestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iamp].requestPackages = angular
                    .copy(loadAllRequestDetailEdit.requestMaterial.requestPackages);
            }
        }

        return loadAllRequestDetailEdit;
    }

    private loadAssignedPackagesToAssignMaterial(rqDetailEdit: RequestDetailEdit,
        copyRequestAssignedMaterialToPackages: RequestAssignedMaterialToPackage[]): RequestDetailEdit {


        if (rqDetailEdit !== undefined &&
            rqDetailEdit.requestMaterial !== undefined &&
            rqDetailEdit.requestMaterial.requestPackages !== undefined &&
            rqDetailEdit.requestMaterial.requestMaterials !== undefined &&
            rqDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined) {


            for (var iamp = 0; iamp < rqDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; iamp++) {


                for (let eachcopyAssignedPackage of copyRequestAssignedMaterialToPackages[iamp].requestPackages) {

                    for (let eachUnAssignedPackage of rqDetailEdit.requestMaterial
                        .requestAssignedMaterialToPackage[iamp].requestPackages) {

                        if (eachUnAssignedPackage.recordNumber === eachcopyAssignedPackage.recordNumber) {

                            eachUnAssignedPackage.quantity =
                                angular.copy(eachcopyAssignedPackage.quantity);
                            eachUnAssignedPackage.packageId =
                                angular.copy(eachcopyAssignedPackage.packageId);
                        }
                    }

                }

            }
        }

        return rqDetailEdit;
    }



    get isShippingDetailsStep(): boolean {
        return this.currentStep === this.shippingDetailsStep;
    }

    get isAddMaterialsStep(): boolean {
        return this.currentStep === this.addMaterialsStep;
    }

    get isAddPackagesStep(): boolean {
        return this.currentStep === this.addPackagesStep;
    }

    get isAssignMaterialsToPackagesStep(): boolean {
        return this.currentStep === this.assignMaterialsToPackagesStep;
    }

    get isPickupInformationStep(): boolean {
        return this.currentStep === this.pickupInformationStep;
    }


    get isExtraDetailsStep(): boolean {
        return this.currentStep === this.extraDetailsStep;
    }
    get isConfirmationStep(): boolean {
        return this.currentStep === this.confirmationStep;
    }

    onClickofAddPackagesNext(): Promise<boolean> {
        const promise = new Promise<boolean>((resolve, reject) => {
            this.adjustPackagesToAssignMaterials();
            this.calculateAssignedPcOfAssignedMaterials();
            resolve(true);
        });
        return promise;
    }
    private adjustPackagesToAssignMaterials() {
        if (this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestMaterial !== undefined &&
            this.requestDetailEdit.requestMaterial.requestPackages !== undefined &&
            this.requestDetailEdit.requestMaterial.requestPackages.filter(o => !o.isDeleted).length === 1) {

            this.adjustPackagesToAssignMaterialsIfPackageIsSingle();
        }

    }

    private adjustPackagesToAssignMaterialsIfPackageIsSingle() {
        if (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined) {

            for (var i = 0; i < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; i++) {
                if (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i] !== undefined &&
                    this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages !==
                    undefined &&
                    this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages
                        .filter(o => !o.isDeleted)
                        .length ===
                    1 &&
                    !this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestMaterials
                        .isDeleted) {

                    this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages
                        .filter(o => !o.isDeleted)[0].quantity =
                        angular.copy(Number(this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i]
                            .requestMaterials
                            .quantity));

                    this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].assignedPc =
                        angular.copy(Number(this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i]
                            .requestMaterials
                            .quantity));
                }
            }
        }
    }

    private calculateAssignedPcOfAssignedMaterials() {
        for (var iam = 0; iam < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; iam++) {
            if (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam] !== undefined &&
                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestMaterials !==
                undefined &&
                !this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestMaterials
                    .isDeleted) {
                var assignedPc = 0;
                for (let assignedMaterialRequestPackage of this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestPackages.filter(o => !o.isDeleted)) {

                    assignedPc = assignedPc + (assignedMaterialRequestPackage.quantity !== undefined && assignedMaterialRequestPackage.quantity !== null ?
                        assignedMaterialRequestPackage.quantity : 0);
                }

                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].assignedPc = angular
                    .copy(assignedPc);
            }
        }
    }

    onClickofAssignMaterialToPackagesNext(): Promise<boolean> {
        const promise = new Promise<boolean>((resolve, reject) => {
            if (this.isNotAssignedPackagesExist()) {
                this._notificationService
                    .showAlertWithOk('There are Unassigned Packages in Assign Materials. Please remove or assign materials to these packages.');
                resolve(false);
            } else if (this.isGrossWeightLessThanTotalNetWeight()) {
                this._notificationService
                    .showAlertWithOk('Total Gross Weight per Package cannot be less than the Total Net Weight of the Materials assigned to the Package.  Revise the Gross Weight of the Package, the Net Weight of the Materials, or add another Package');
                resolve(false);
            } else {

                resolve(true);
            }
        });

        return promise;
    }

    private isGrossWeightLessThanTotalNetWeight(): boolean {
        var grossWeight = 0;
        var assignedQuantity = 0;
        var assignedWeight = 0;
        var materialNetWeight = 0;
        var packages = [];

        for (var i = 0; i < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; i++) {
            for (var j = 0; j < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages.length; j++) {

                materialNetWeight = this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestMaterials.netWeight;
                materialNetWeight = (materialNetWeight == null || materialNetWeight == undefined) ? 0 : materialNetWeight;

                grossWeight = this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages[j].grossWeight;
                grossWeight = (grossWeight == null || grossWeight == undefined) ? 0 : grossWeight;

                assignedQuantity = this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages[j].quantity;
                assignedQuantity = (assignedQuantity == null || assignedQuantity == undefined) ? 0 : assignedQuantity;

                assignedWeight = assignedQuantity * materialNetWeight;

                if (i == 0) {
                    var pkg = { id: j, packageGrossWeight: grossWeight, assignedMaterialWeight: assignedWeight };
                    packages.push(pkg);
                }
                else {
                    var existingPkg = this.$filter('filter')(packages, function (d) { return d.id === j; })[0];
                    existingPkg.assignedMaterialWeight = existingPkg.assignedMaterialWeight + assignedWeight;
                }
            }
        }

        for (let pkg of packages) {
            if (pkg.packageGrossWeight < pkg.assignedMaterialWeight)
                return true;
        }

        return false;
    }

    private isNotAssignedPackagesExist(): boolean {

        if (this.requestDetailEdit !== undefined && this.requestDetailEdit.requestMaterial !== undefined &&
            this.requestDetailEdit.requestMaterial.requestPackages !== undefined &&
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined) {
            let assignedRequestPackagesRecordNumber: Array<number> = [];
            for (let eachRequestAssignedMaterialToPackage of
                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage) {
                for (let recordNumber of eachRequestAssignedMaterialToPackage.requestPackages
                    .filter(o => (o.quantity !== undefined && o.quantity !== null && o.quantity > 0 && !o.isDeleted)).map(o => o.recordNumber)) {
                    if (assignedRequestPackagesRecordNumber.filter(o => o === recordNumber).length === 0) {
                        assignedRequestPackagesRecordNumber.push(recordNumber);
                    }
                }

            }

            let allRequestPackagesRecordNumber: Array<number> = [];
            allRequestPackagesRecordNumber = angular.copy(this.requestDetailEdit.requestMaterial.requestPackages
                .filter(o => !o.isDeleted).map(o => o.recordNumber));


            let unAssignedPackagesRecordNumber = _
                .difference(allRequestPackagesRecordNumber.sort(), assignedRequestPackagesRecordNumber.sort());

            if (unAssignedPackagesRecordNumber !== undefined &&
                unAssignedPackagesRecordNumber !== null &&
                unAssignedPackagesRecordNumber.length === 0) {
                return false;
            }

        }

        return true;
    }


    submitRequestDetails(): Promise<boolean> {
        this.isLoading = true;

        const requestLetterHtml = document.getElementById('request-letter').innerHTML;
        this.requestDetailEdit.requestLetter = new RequestLetter(requestLetterHtml, '', 0, '');

        return this._addRequestService.submitRequestWithAttachments(this.requestDetailEdit, this.attachmentFormData).then(saveResult => {
            this.isLoading = false;
            this.isSaved = true;
            this.trackingId = saveResult.trackingId;
            this.city = saveResult.city;
            this.pickupAddressLine1 = saveResult.pickupAddressLine1;
            this.pickupCountry = saveResult.pickupCountry;
            this.destinationCountry = saveResult.destinationCountry;
            this.transportationMode = saveResult.transportationMode;
            this.packageType = saveResult.packageType;
            this.totalShippingCost = saveResult.totalShippingCost;
            this.isPackageSizeGreater = saveResult.isPackageSizeGreater; 
            this.orderNumber = saveResult.orderNumber;
            this.deliveryNumber = saveResult.deliveryNumber;
            this.sapErrorMessage = saveResult.sapErrorMessage;
            return true;

        }, saveResult => {

            this.isLoading = false;
            this._notificationService.showToast(this.extractError(saveResult));
            return false;
        });

    }
    private extractError(result): string {
        return (result && result.errors && result.errors.length > 0) ? result.errors[0] : 'Unexpected error occurred';
    }

    shipmentNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestShipment !== undefined;
    }

    consigneeNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestConsignee !== undefined;
    }

    pickupDetailsNotUndefined(): boolean {
        return this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestDetail !== undefined &&
            this.requestDetailEdit.requestDetail.requestPickupDetail !== undefined;
    }

    // TODO CKH - TEST THIS PAGE
    redirectToSearchPage(): Promise<any> {
        if (this._userInfoService.getUserInfo().role.indexOf("receiver") >= 0) {
            return Promise.resolve(
                this._$state.go(requestDetailEditState.name, { trackingId: this.trackingId })
            );
        } else {
            return Promise.resolve(
                this._$state.go(requestDetailState.name, { trackingId: this.trackingId })
            );
        }
    }

    trackingId: string;
    city: string;
    pickupAddressLine1: string;
    pickupCountry: string;
    destinationCountry: string;
    transportationMode: string;
    packageType: string;
    totalShippingCost: number;
    isPackageSizeGreater: boolean;
    orderNumber: number;
    deliveryNumber: number;
    sapErrorMessage : string;


    hasChanges(): boolean {
        if (!this.isConfirmationStep) {
            var unmodifiedRequestDetailEdit = angular.copy(this.getJsonFormatOfRequestDetailEditModel(angular.copy(this.unmodifiedRequestDetailEdit)));
            var modifiedRequestDetailEdit = angular.copy(this.getJsonFormatOfRequestDetailEditModel(angular.copy(this.requestDetailEdit)));

            return !angular.equals(unmodifiedRequestDetailEdit, modifiedRequestDetailEdit);
        }
        return false;
    }

    private getJsonFormatOfRequestDetailEditModel(requestDetailEdit: RequestDetailEdit): any {
        var requestShipment;
        if (requestDetailEdit.requestDetail.requestShipment !== undefined) {
            requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate = angular.copy(this
                .formatDateWithTimeZone(angular.copy(requestDetailEdit.requestDetail.requestShipment.requestedDeliveryDate)));
            requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate = angular.copy(this
                .formatDateWithTimeZone(angular.copy(requestDetailEdit.requestDetail.requestShipment.shipmentReadyDate)));
            requestShipment = requestDetailEdit.requestDetail.requestShipment.toJson();
        }

        var requestConsignee;
        if (requestDetailEdit.requestDetail.requestConsignee !== undefined) {
            requestConsignee = requestDetailEdit.requestDetail.requestConsignee.toJson();
        }
        var requestPickupDetail;
        if (requestDetailEdit.requestDetail.requestPickupDetail !== undefined) {
            requestPickupDetail = requestDetailEdit.requestDetail.requestPickupDetail.toJson();
        }
        var requestDetail = { requestShipment, requestConsignee, requestPickupDetail };

        var requestMaterials = [];

        if (requestDetailEdit.requestMaterial.requestMaterials !== undefined) {
            for (var im = 0; im < requestDetailEdit.requestMaterial.requestMaterials.length; im++) {
                requestMaterials[im] = requestDetailEdit.requestMaterial.requestMaterials[im].toJson();
            }
        }

        var requestPackages = [];

        if (requestDetailEdit.requestMaterial.requestMaterials !== undefined) {
            for (var ip = 0; ip < requestDetailEdit.requestMaterial.requestPackages.length; ip++) {
                requestPackages[ip] = requestDetailEdit.requestMaterial.requestPackages[ip].toJson();
            }
        }

        var requestAssignedMaterialToPackage = [];

        if (requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined) {
            for (var iam = 0; iam < requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; iam++) {

                var assignedPc = requestDetailEdit.requestMaterial
                    .requestAssignedMaterialToPackage[iam].assignedPc;

                var requestMaterialEdit = requestDetailEdit.requestMaterial
                    .requestAssignedMaterialToPackage[iam].requestMaterials.toJson();

                var packages = [];
                var indexOfPackages = 0;
                for (var iamp = 0; iamp < requestDetailEdit.requestMaterial
                    .requestAssignedMaterialToPackage[iam].requestPackages.length; iamp++) {

                    if (requestDetailEdit.requestMaterial
                        .requestAssignedMaterialToPackage[iam].requestPackages[iamp] !==
                        undefined &&
                        requestDetailEdit.requestMaterial
                            .requestAssignedMaterialToPackage[iam].requestPackages[iamp].quantity !==
                        undefined &&
                        requestDetailEdit.requestMaterial
                            .requestAssignedMaterialToPackage[iam].requestPackages[iamp].quantity !==
                        null &&
                        requestDetailEdit.requestMaterial
                            .requestAssignedMaterialToPackage[iam].requestPackages[iamp].quantity >
                        0
                    ) {

                        packages[indexOfPackages] = requestDetailEdit.requestMaterial
                            .requestAssignedMaterialToPackage[iam].requestPackages[iamp].toJson();
                        indexOfPackages = indexOfPackages + 1;
                    }
                }

                requestAssignedMaterialToPackage[iam] = { assignedPc, requestMaterialEdit, packages }
            }
        }

        var requestAttachments = [];

        var requestMaterial = { requestMaterials, requestPackages, requestAssignedMaterialToPackage };
        var rqDetailEdit = { requestDetail, requestMaterial };
        return rqDetailEdit;

    }
    private formatDateWithTimeZone(date: Date): Date {
        return (this.$filter("date")(date, "yyyy-MM-dd")) as any;
    }

}  


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/addRequest/controllers/addRequestController.ts
 **/